// import { dispatchAction, ellipsis } from '../utilities/utility';
import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, BIZ_DATA, AUTH_ACCESS_TOKEN } from '../constants/actions';
// eslint-disable-next-line import/no-cycle
import { ApiService } from '../config/api/api-service';
import { ApiLibrary } from '../config/api/api-library';
import { LABELS, SESSION_KEYS } from '../utilities/constants/index';
import { setSession, removeSession } from '../services/storage-service';
import { getBizCode } from '../services/business-details-service';
import { getLoginAccountId, getPaccessId } from '../services/auth-details-service';
// eslint-disable-next-line import/no-cycle
import { getDisplayFields } from '../utilities/utility';

// Request OAuth Token
export const oauthToken = (payload) => async (dispatch) => {
  // Make a POST request to obtain the OAuth token
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.OAUTH_TOKEN}`, payload);

  if (payload?.grant_type === LABELS.GRANT_TYPE.PASSWORD || payload?.grant_type === LABELS.GRANT_TYPE.REFRESH_TOKEN) {
    // Handle login success or failure for password grant type
    if (response?.status === 200) {
      await dispatch({ type: LOGIN_SUCCESS, payload: response?.data });
      setSession(`${response.data?.realm}${SESSION_KEYS.LOGIN_RES}`, response?.data, true);
    } else {
      await dispatch({ type: LOGIN_FAILURE, payload: response?.data?.error_description });
    }
  } else if (payload?.grant_type === LABELS.GRANT_TYPE.CLIENT_CREDENTIALS) {
    if (response?.status === 200) {
      await dispatch({ type: AUTH_ACCESS_TOKEN, payload: response?.data });
    }
  }

  return response;
};

// Get Active Businesses for a User Account
export const getBizUsrAcctActiveBusinesses = (emailId) => async () => {
  // Make a GET request to retrieve active businesses for a user account
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_USR_ACCT_ACTIVE_BIZS}/${emailId}`);
  return response;
};

// Get Active Businesses for a User Account by uuId
export const getBizUsrActiveBusinessesByUuId = (uuId, payload) => async () => {
  // Make a GET request to retrieve active businesses for a user account
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_USR_ACCT_ACTIVE_BIZS_UUID}/${uuId}`,
    payload,
  );
  return response;
};

// Forgot Password
export const forgotPwd = (payload) => async (dispatch) => {
  // Make a POST request for password recovery
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_FORGOT_PWD}`, payload);
  await dispatch({ type: AUTH_ACCESS_TOKEN, payload: {} });
  return response;
};

// Verify OTP
export const verifyOTP = (id, payload) => async (dispatch) => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_VERIFY_OTP}`;
  url = id ? `${url}/${id}` : url;

  // Make a POST request to verify the OTP
  const response = await ApiService.Post(`${url}`, payload);
  await dispatch({ type: AUTH_ACCESS_TOKEN, payload: {} });

  return response;
};

// Resend OTP
export const resendOTP = (payload) => async () => {
  // Make a POST request to resend the OTP
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_RESEND_OTP}`, payload);

  return response;
};

// Reset Password
export const resetPassword = (uuid, payload) => async (dispatch) => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_RESET_PWD}`;
  url = uuid ? `${url}/${uuid}` : url;

  // Make a POST request to reset the password
  const response = await ApiService.Post(`${url}`, payload);
  await dispatch({ type: AUTH_ACCESS_TOKEN, payload: {} });
  return response;
};

// Update Password
export const updatePassword = (payload) => async () => {
  // Make a POST request to update the password
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_UPDATE_PWD}`, payload);

  return response;
};

// Create Business Account
export const bizAccountCreate = (payload) => async () => {
  // Make a POST request to create a business account
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_CREATE}`, payload);

  return response;
};

// Validate Email for Business User Account
export const bizUserAccountValidateEmail = (emailId, payload) => async () => {
  // Make a GET request to validate the email for a business user account
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_USR_ACCT_VALIDATE_EMAIL}/${emailId}`,
    payload,
  );

  return response;
};

// Create H360 Business Request
export const bizH360ReqCreate = (payload) => async () => {
  // Make a POST request to create an H360 business request
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.H360_BIZ_REQ_CREATE}`, payload);

  return response;
};

// Get Business Details
export const getBizDetails = async (bizCode) => {
  // Make a GET request to retrieve business details
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.HOME_BIZ}/${bizCode}`);
  return response;
};

// Get Business Account Details
export const getBizAccountDetails = (emailId) => async () => {
  // Make a GET request to retrieve business account details
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT}/${emailId}`);

  return response;
};

// Request OAuth Revoke Token
export const oauthRevokeToken = () => async (dispatch) => {
  // Make a POST request to obtain the OAuth token
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.OAUTH_REVOKE_TOKEN}`);
  // Handle login success or failure for password grant type
  removeSession(`${getBizCode()}${SESSION_KEYS.LOGIN_RES}`);
  // if (!response?.error) {
  await dispatch({ type: LOGOUT, payload: {} });
  await dispatch({ type: BIZ_DATA, payload: {} });
  // }
  return response;
};

// ==================================================== TEAM APIS ==========================================================

/**
 * The function `getBizTeamsList` retrieves a list of business teams based on the account ID and an
 * optional keyword.
 * @param acctId - The `acctId` parameter is the account ID that is used to identify a specific account
 * in the system. It is used to filter the business teams list based on the account ID.
 * @param keyword - The `keyword` parameter is used to filter the teams list based on a specific
 * keyword. It is an optional parameter, meaning it can be omitted if not needed.
 * @returns The response from the ApiService.Get(url) call is being returned.
 */
export const getBizTeamsList = (acctId, keyword, nextPageIndex) => async () => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2.TEAM_LIST}/${nextPageIndex}/15`;
  url = keyword ? `${url}?acctId=${acctId}&keyword=${keyword}` : `${url}?acctId=${acctId}`;

  const response = await ApiService.Get(url);
  return response;
};

/**
 * The function `verifyBizTeamName` sends a GET request to the API to verify a business team name.
 * @param teamName - The `teamName` parameter is a string that represents the name of a business team.
 * @returns The response from the API call is being returned.
 */
export const verifyBizTeamName = (teamName) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.VERIFY_TEAM_NAME}${teamName}`);
  return response;
};

/**
 * The `bizTeamCreateName` function sends a POST request to create a business team using the provided
 * payload.
 * @param payload - The `payload` parameter is an object that contains the data needed to create a
 * business team. It could include properties such as team name, team members, team description, etc.
 * @returns The response from the API call is being returned.
 */
export const bizTeamCreateName = (payload) => async () => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2.CREATE_BIZ_TEAM}`, payload);
  return response;
};

/**
 * The `bizTeamUpdate` function is an asynchronous function that sends a POST request to update a
 * business team using the provided `id`.
 * @param id - The `id` parameter is the identifier of the business team that you want to update.
 * @returns The response from the API call is being returned.
 */
export const bizTeamUpdate = (id, payload) => async () => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2.UPDATE_BIZ_TEAM}${id}`, payload);
  return response;
};

/**
 * The function `bizGetAccountsList` is an asynchronous function that makes a GET request to the
 * `ACCOUNTS_LIST` endpoint and returns the response.
 * @returns The response from the API call is being returned.
 */
export const bizGetAccountsList = (keyword, pageIndex) => async () => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2.ACCOUNTS_LIST}/${pageIndex}/15`;
  url = keyword ? `${url}?keyword=${keyword}` : url;
  const response = await ApiService.Get(url);
  return response;
};

/**
 * The function `bizGetAccountsMedia` is an asynchronous function that makes an API call to retrieve
 * account media data based on the provided account ID.
 * @param acctId - The `acctId` parameter is the ID of the account for which you want to retrieve
 * media.
 * @returns The response from the API call is being returned.
 */
export const bizGetAccountsMedia = (iconUrl) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_ACCOUNT_MEDIA}${iconUrl}`);
  return response;
};

/**
 * The function `bizGetTeamDetail` is an asynchronous function that makes an API call to retrieve the
 * team detail based on the provided ID.
 * @param id - The `id` parameter is the unique identifier of the team for which you want to retrieve
 * the details.
 * @returns The response from the API call is being returned.
 */
export const bizGetTeamDetail = (id) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_TEAM_DETAIL}${id}`);
  return response;
};

/**
 * The function `bizGetTeamMembersList` makes an API call to retrieve a list of team members based on
 * the provided ID.
 * @param id - The `id` parameter is the identifier of the team for which you want to retrieve the list
 * of team members.
 * @returns The response from the API call is being returned.
 */
export const bizGetTeamMembersList = (nextPageIndex, id, keyword) => async () => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_GET_TEAM_MEMBERS}${id}/${nextPageIndex}/15`;
  url = keyword ? `${url}?keyword=${keyword}` : url;

  const response = await ApiService.Get(url);
  return response;
};

/**
 * The `bizUpdateTeamMembersList` function makes an API call to update the details of a team member.
 * @param id - The `id` parameter is the unique identifier of the team for which you want to update the
 * members list.
 * @returns The response from the API call is being returned.
 */
export const bizUpdateTeamMembers = (id, payload) => async () => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_BASIC_ROUTE}${id}/member/update`,
    payload,
  );
  return response;
};

/**
 * The `bizAddTeamMember` function is an asynchronous function that sends a POST request to add a team
 * member to a business using the provided ID and payload.
 * @param id - The `id` parameter is the identifier of the business to which the team member will be
 * added.
 * @param payload - The `payload` parameter is an object that contains the data to be sent in the
 * request body. It typically includes information about the team member being added, such as their
 * name, email, role, etc.
 * @returns The response from the API call is being returned.
 */
export const bizAddTeamMember = (id, payload) => async () => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_BASIC_ROUTE}${id}/member/add`,
    payload,
  );
  return response;
};

/**
 * The `bizRemoveTeamMember` function is an asynchronous function that sends a POST request to remove a
 * team member from a business using the provided `id` and `payload`.
 * @param id - The `id` parameter is the identifier of the team or group from which you want to remove
 * a member.
 * @param payload - The `payload` parameter is an object that contains the data to be sent in the
 * request body. It typically includes information about the team member to be removed, such as their
 * ID or any other relevant details.
 * @returns The response from the API call is being returned.
 */
export const bizRemoveTeamMember = (id, payload) => async () => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_BASIC_ROUTE}${id}/member/remove`,
    payload,
  );
  return response;
};

/**
 * The function `bizGetUserList` is an asynchronous function that makes a POST request to a specific
 * API endpoint and returns the response.
 * @returns The response from the API call is being returned.
 */
export const bizGetUserList = (userId) => async () => {
  const response = userId
    ? await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_USERS_ACCOUNT_LIST}?ids=${userId}`)
    : await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_USERS_ACCOUNT_LIST}`);
  return response;
};

/**
 * The function `bizUpdateTeamOwner` is an asynchronous function that updates the owner of a team by
 * making a POST request to an API endpoint.
 * @param teamId - The teamId parameter represents the unique identifier of the team that you want to
 * update the owner for. It is used to specify which team's owner should be transferred.
 * @param userId - The `userId` parameter represents the unique identifier of the user who will become
 * the new owner of the team.
 * @returns the response from the API call.
 */
export const bizUpdateTeamOwner = (teamId, userId) => async () => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_BASIC_ROUTE}/${teamId}/transferOwner/${userId}`,
  );
  return response;
};

// =========================================================================================================================
// Get Users Accounts
export const getUserAccounts = async (nextPageIndex, pageSize, value) => {
  // Make a GET request to retrieve user account list
  const response = value
    ? await ApiService.Get(
      `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT}/${nextPageIndex}/${pageSize}?${value}`,
    )
    : await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT}/${nextPageIndex}/${pageSize}`);
  return response;
};

// Get MyInvitees User Accounts
export const getUserMyInviteesList = async (nextPageIndex, pageSize, userAccountId, value) => {
  // Make a GET request to retrieve user my invitees account list
  const response = value
    ? await ApiService.Get(
      `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT}/${nextPageIndex}/${pageSize}?invitedBy=${userAccountId}&${value}`,
    )
    : await ApiService.Get(
      `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT}/${nextPageIndex}/${pageSize}?invitedBy=${userAccountId}`,
    );
  return response;
};

// Verify Users Accounts while uploading the csv data
export const verifyUserInviteeAccountsUpload = async (payload) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2.VERIFY_USER_ACCOUNT_INVITE_UPLOAD}`,
    payload,
  );
  return response;
};

// Get User Account Details
export const getUserAccountsDetails = async (userId = null) => {
  // Make a GET request to retrieve user account details
  let apiAccountDetails = `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT_DETAILS}`;
  if (userId) {
    apiAccountDetails += `/${userId}`;
  }

  const response = await ApiService.Get(apiAccountDetails);
  return response;
};

// Post Request to Send Invite
export const sendAccountInvite = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.SEND_INVITE}`, payload);
  return response;
};

// Post Request to Update User Accounts Details
export const updateUserAccountDetails = async (payload, userId) => {
  let userUpdateApi = `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT_DETAILS}`;
  if (userId) {
    userUpdateApi += `/update/${userId}`;
  }
  const response = await ApiService.Post(userUpdateApi, payload);
  return response;
};

// GET request to retrieve user account APP list
export const getUserAppList = async (userId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.USER_ACCOUNT_APP_LIST}/${userId}`);
  return response;
};

// GET request to retrieve user account ACTIVITY list
export const getUserActivityList = async (userId) => {
  // Make a GET request to retrieve user account details
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.USER_ACCOUNT_ACTIVITY_LIST}/?userId=${userId}`,
  );
  return response;
};

// Get User Account Updated Role Type
export const updateUserRoleTyle = async (userId, roleType) => {
  // Make a GET request to update user account role
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT_DETAILS}/${userId}/role/update/${roleType}`,
  );
  return response;
};

// Get User Account Updated Account Status
export const updateUserAccountStatus = async (userId, status) => {
  // Make a GET request to update user account status
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.UPDATE_USER_ACCOUNT_DETAILS}/${userId}/status/${status}`,
  );
  return response;
};

// Send the Invitation to the user
export const resentInvitation = async (userId) => {
  // Make a GET request to update user account status
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT_DETAILS}/resend/invitation/${userId}`,
  );
  return response;
};

// Post Request to Get Calendar Data
export const getCalendarData = async (payload, isOptionSet) => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2.HOME_CALENDAR}`;

  if (isOptionSet?.value) {
    url = `${url}?${isOptionSet?.value}`;
  } else {
    url = `${url}`;
  }

  const response = await ApiService.Post(url, payload);
  return response;
};

// Get Request to Get Home page Fields Data
export const getHomeFields = async (userId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.HOME_FIELDS}/${userId}`);
  return response;
};

// Get Activity List
export const getActivityList = async (nextPageIndex, pageSize, userId) => {
  const response = userId
    ? await ApiService.Get(
      `${ApiService.baseURL}/${ApiLibrary?.V2?.USER_ACCOUNT_ACTIVITY_LIST}${nextPageIndex}/${pageSize}?userId=${userId}`,
    )
    : await ApiService.Get(
      `${ApiService.baseURL}/${ApiLibrary?.V2?.USER_ACCOUNT_ACTIVITY_LIST}${nextPageIndex}/${pageSize}`,
    );
  return response;
};

// ============================================= Report Apis =================================================

/**
 * The function `getReportList` is an asynchronous function that makes a GET request to retrieve a list
 * of reports from an API.
 * @returns The response from the API call is being returned.
 */
export const getReportList = (serviceType) => async () => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_REPORTS_LIST}`;
  if (serviceType) {
    url += `?type=${serviceType}`;
  }
  const response = await ApiService.Get(url);
  return response;
};

/**
 * The function `getReportDetailInfo` makes an asynchronous API call to retrieve detailed information
 * about a report based on its ID.
 * @param id - The `id` parameter is the identifier of the report for which you want to retrieve
 * detailed information.
 * @returns the response from the API call.
 */
export const getReportDetailInfo = (id) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.GET_REPORT_DETAIL_INFO}/${id}`);
  return response;
};

/**
 * The function `getReportDetailList` is an asynchronous function that makes an API call to retrieve a
 * report detail list based on the provided `id`.
 * @param id - The `id` parameter is the identifier of the report for which you want to retrieve the
 * detail list.
 * @returns The response from the API call is being returned.
 */
export const getReportDetailList = (id) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.GET_REPORT_DETAIL_LIST}/${id}`);
  return response;
};

/**
 * The function `getReportFormField` is an asynchronous function that makes an API call to retrieve a
 * specific form field based on the given type.
 * @param type - The `type` parameter is used to specify the type of form field that you want to
 * retrieve from the API. It is passed as an argument to the `getReportFormField` function.
 * @returns The response from the API call is being returned.
 */
export const getReportFormField = (type) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.GET_FORM_FIELD}/${type}`);
  return response;
};

/**
 * The function `createNewReport` sends a POST request to the API with the provided payload to create a
 * new report.
 * @param payload - The `payload` parameter is an object that contains the data needed to create a new
 * report. It could include information such as the report title, description, date, and any other
 * relevant details.
 * @returns The response from the API call is being returned.
 */
export const createNewReport = (payload) => async () => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.CREATE_NEW_REPORT}`, payload);
  return response;
};
// ===========================================================================================================
// Get Flows List
export const getFlowsList = async (type) => {
  const response = type
    ? await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.FLOWS_LIST}?type=${type}`)
    : await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.FLOWS_LIST}`);
  return response;
};

// Get Flows Processors List
export const getProcessorList = async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.FLOWS_PROCESSOR_LIST}`);
  return response;
};

// =========================================================================================================================
// Get Look Up data based on the refId, lookupType, display fields.
export const getLookupData = async (value, lookupType) => {
  let getURL = `${ApiService.baseURL}/${ApiLibrary?.V2?.LOOKUP_API}/${value}`;
  if (lookupType) {
    getURL = `${ApiService.baseURL}/${ApiLibrary?.V2?.LOOKUP_API}/${lookupType}/${value}`;
  }
  if (value !== null && value !== undefined) {
    const response = await ApiService.Get(`${getURL}`);
    return response;
  }
};

// =========================================================================================================================
// Get the comments list by specific field based on the txn id.
export const getCommentsList = async (pageIndex, pageSize, fieldId, txnId) => {
  const url =
    fieldId !== '' && fieldId !== undefined
      ? `${ApiService.baseURL}/${ApiLibrary?.V2?.COMMENTS_LIST}/${pageIndex}/${pageSize}?forId=${fieldId}&refId=${txnId}`
      : `${ApiService.baseURL}/${ApiLibrary?.V2?.COMMENTS_LIST}/${pageIndex}/${pageSize}?refId=${txnId}`;
  const response = await ApiService.Get(`${url}`);
  return response;
};

// =========================================================================================================================
// Get the comments list by specific field based on the txn id.
export const deleteCommentByCommentId = async (cmntId) => {
  const response = await ApiService.Delete(`${ApiService.baseURL}/${ApiLibrary?.V2?.DELETE_CMNT}/${cmntId}`);
  return response;
};

// =========================================================================================================================

// save the comments
export const addNewComment = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.COMMENT_SAVE}`, payload);
  return response;
};

// =========================================================================================================================
// Get the comments list by specific field based on the txn id.
export const updateComment = async (payload, cmntId) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.COMMENT_UPDATE}/${cmntId}`, payload);
  return response;
};

/**
 * The function `updateTxnDataById` makes an asynchronous API call to retrieve transaction details by
 * ID.
 * @param cmntId - The `cmntId` parameter is the ID of a transaction data that needs to be updated.
 * @returns The response from the API call is being returned.
 */
export const updateTxnDataById = (cmntId) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_DETAILS}/${cmntId}`);
  return response;
};

// ========================================== APPS SETTINGS =============================================================
// Get Business Apps Users List
export const bizGetSelectUserAccountsList = async (userId) => {
  const response = userId
    ? await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_USERS_ACCOUNT_LIST}?ids=${userId}`)
    : await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_USERS_ACCOUNT_LIST}`);
  return response;
};

// Get Apps Users Perspective List
export const bizGetUserPerspectiveList = async (svcType) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_GET_PERSPECTIVE_LIST}/${svcType}`);
  return response;
};

// Get Apps Users Accounts Enable List
export const bizGetUserAccountsEnableList = async (svcType) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2.GET_ENABLE_USER_ACCOUNT_LIST}/${svcType}?enabledFor=ACCOUNT`,
  );
  return response;
};

// Post request to add user to the app
export const addAppUser = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.ADD_USER}`, payload);
  return response;
};

export const removeUserPerspective = async (userId) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.REMOVE_USER_PERSPECTIVE}/${userId}?assignedFor=ACCOUNT`,
  );
  return response;
};

// Delete request to remove user to the app
export const removeAppUser = async (userId) => {
  const response = await ApiService.Delete(`${ApiService.baseURL}/${ApiLibrary?.V2?.REMOVE_USER}/${userId}`);
  return response;
};

// Post request to update apps notifications
export const updateAppsNotification = async (payload, userId, svcType) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.UPDATE_MY_TRANSACTIONS_NOTIFICATIONS}/${userId}/alert/update/${svcType}`,
    payload,
  );
  return response;
};

// Get apps activity list
export const getAppsActivityList = async (nextPageIndex, pageSize, svcType) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.APPS_ACTIVITY_LIST}/${nextPageIndex}/${pageSize}?targetType=${svcType}`,
  );
  return response;
};
// ========================================================================================================================

// =========================================================================================================================
// create txn
export const createTxnForm = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_CREATE}`, payload);
  return response;
};

// ===================================================== NOTIFICATIONS ==========================================================
// Get Users Notifications List
export const getUserNotificationsList = async (accountId, pageIndex, pageSize) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.USER_NOTIFICATIONS_LIST}/${accountId}/${pageIndex}/${pageSize}`,
  );
  return response;
};

// Update Users Notifications Status
export const updateUserNotifications = async (userId, payload) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.USER_NOTIFICATION_UPDATE}/${userId}`,
    payload,
  );
  return response;
};

// Get Pong Request Notifications
export const getPongRequestNotifications = async (accountId, streamSessionId) => {
  const hostUrl = ApiService.baseURL.replace("/bapi", "");
  const response = await ApiService.Get(
    `${hostUrl}/${ApiLibrary.NOTIFICATION_PONG_REQUEST}?acctId=${accountId}&sessionId=${streamSessionId}`,
    {},
  );
  return response;
};
// =============================================================================================================================

// =============================================== CHANGE BUSINESS ===============================================================
// Get users all business accounts list
export const getUserBusinessAccountsList = async (userEmailId) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.USER_BUSINESS_ACCOUNT_LIST}/${userEmailId}`,
  );
  return response;
};

// Get active business list
export const getBusinessList = async (businessIds) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.BUSINESS_LIST}?id=${businessIds}`);
  return response;
};
// ========================================================================================================================

// =============================================== BUSINESS PROFILE ========================================================
// Business Profile Forgot Password
export const businessProfileForgotPwd = async (payload) => {
  // Make a POST request for business profile password recovery
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_FORGOT_PWD}`, payload);
  return response;
};

// Business Profile Verify OTP
export const businessProfileVerifyOTP = async (id, payload) => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_VERIFY_OTP}`;
  url = id ? `${url}/${id}` : url;
  // Make a POST request for business verify OTP
  const response = await ApiService.Post(`${url}`, payload);
  return response;
};

// Business Profile Resend OTP
export const businessProfileResendOTP = async (payload) => {
  // Make a POST request to business profile resend OTP
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_RESEND_OTP}`, payload);
  return response;
};

// Business Profile Update New Password
export const businessProfileUpdatePassword = async (uuid, payload) => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.BIZ_ACCT_UPDATE_PWD}`;
  url = uuid ? `${url}/${uuid}` : url;
  // Make a POST request to update the business profile password
  const response = await ApiService.Post(`${url}`, payload);
  return response;
};

// Business Profile Update User Alert Accounts Aetails
export const getBusinessProfileAlertAccountsDetails = async (userId, alert, payload) => {
  // Make a POST request to update business profile alert account details
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT_DETAILS}/${userId}/${alert}`,
    payload,
  );
  return response;
};

// Get business profile notification status
export const updateUserNotificationStatus = async (userAccountId, status) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT_DETAILS}/${userAccountId}/alert/status/${status}`,
  );
  return response;
};
// ==========================================================================================================================

// Add Token api to send MSAL token in our api.
export const addMsalToken = (payload, headers) => async (dispatch) => {
  // export const addMsalToken = async (payload, headers) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.ADD_MSAL_TOKEN}`, payload, headers);
  if (response?.status === 200) {
    setSession(`${response.data?.realm}${SESSION_KEYS.LOGIN_RES}`, response?.data, true);
    await dispatch({ type: LOGIN_SUCCESS, payload: response?.data });
  } else {
    await dispatch({ type: LOGIN_FAILURE, payload: response?.data?.error_description });
  }
  return response;
};

// Add Token api to send google token in our api.
export const addGoogleToken = (payload, headers) => async (dispatch) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.ADD_GOOGLE_TOKEN}`, payload, headers);
  if (response?.status === 200) {
    setSession(`${response.data?.realm}${SESSION_KEYS.LOGIN_RES}`, response?.data, true);
    await dispatch({ type: LOGIN_SUCCESS, payload: response?.data });
  } else {
    await dispatch({ type: LOGIN_FAILURE, payload: response?.data?.error_description });
  }
  return response;
};

// ==================================================== Transaction Apis =======================================================

export const getTransactionList =
  (id, savedFilterId, payload, isOptionSet, selectedOwnerData, pageValue, defaultViewMode) => async () => {
    let url = `${ApiService.baseURL}/${ApiLibrary?.V2.TR_LIST}/${id}`;

    let mode = 'LIST';
    pageValue.pageSize = 15;
    /* The above code is a switch statement in JavaScript. It checks the value of the variable
    `defaultViewMode` and assigns a value to the variable `mode` based on the value of
    `defaultViewMode`. */
    switch (defaultViewMode) {
      case 'list': {
        mode = 'LIST';
        break;
      }
      case 'table': {
        mode = 'TABLE';
        pageValue.pageSize = 25;
        break;
      }
      case 'catalog': {
        mode = 'CATALOG';
        break;
      }
      default: {
        break;
      }
    }

    /** The above code is checking if the `isOptionSet` variable has a truthy value and if `savedFilterId`
  is defined. If both conditions are true, it constructs a URL with the `savedFilterId` and
  `isOptionSet` values. If only `isOptionSet` has a truthy value, it constructs a URL with only the
  `isOptionSet` value. If only `savedFilterId` is defined, it constructs a URL with only the
  `savedFilterId` value. */
    if (isOptionSet?.value && savedFilterId) {
      url = `${url}/${pageValue.pageIndex}/${pageValue.pageSize}?${savedFilterId}&${isOptionSet?.value}&vMode=${mode}`;
    } else if (savedFilterId && selectedOwnerData?.value) {
      url = `${url}/${pageValue.pageIndex}/${pageValue.pageSize}?${savedFilterId}&${selectedOwnerData?.value}&vMode=${mode}`;
    } else if (isOptionSet?.value) {
      url = `${url}/${pageValue.pageIndex}/${pageValue.pageSize}?${isOptionSet?.value}&vMode=${mode}`;
    } else if (savedFilterId) {
      url = `${url}/${pageValue.pageIndex}/${pageValue.pageSize}?${savedFilterId}&vMode=${mode}`;
    } else if (selectedOwnerData?.value) {
      url = `${url}/${pageValue.pageIndex}/${pageValue.pageSize}?${selectedOwnerData?.value}&vMode=${mode}`;
    } else {
      url = `${url}/${pageValue.pageIndex}/${pageValue.pageSize}?vMode=${mode}`;
    }

    const response = await ApiService.Post(url, payload);
    return response;
  };

export const getTransactionDetails = (id) => async () => {
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2.TR_LOCATION}/${id}`;
  const response = await ApiService.Get(url);
  return response;
};

export const getTransactionLocationData = (id, payload, savedFilterId, isOptionSet, selectedOwnerData) => async () => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2.TR_LOCATION}`;

  if (savedFilterId && isOptionSet?.value) {
    url = `${url}/${payload?.locCriteria?.fieldName === '_Txn_Owner' ? 'owner/list' : 'location'
      }/${id}?${savedFilterId}&${isOptionSet?.value}&vMode=LOCATION`;
  } else if (savedFilterId && selectedOwnerData?.value) {
    url = `${url}/${payload?.locCriteria?.fieldName === '_Txn_Owner' ? 'owner/list' : 'location'
      }/${id}?${savedFilterId}&${selectedOwnerData?.value}&vMode=LOCATION`;
  } else if (isOptionSet?.value) {
    url = `${url}/${payload?.locCriteria?.fieldName === '_Txn_Owner' ? 'owner/list' : 'location'}/${id}?${isOptionSet?.value
      }&vMode=LOCATION`;
  } else if (savedFilterId) {
    url = `${url}/${payload?.locCriteria?.fieldName === '_Txn_Owner' ? 'owner/list' : 'location'
      }/${id}?${savedFilterId}&vMode=LOCATION`;
  } else {
    url = `${url}/${payload?.locCriteria?.fieldName === '_Txn_Owner' ? 'owner/list' : 'location'}/${id}?vMode=LOCATION`;
  }
  const response = await ApiService.Post(url, payload);
  return response;
};

export const updateTxnOwner = (txnId, userId) => async () => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_ASSIGN}/${txnId}/${userId}`);
  return response;
};

export const transactionFilterList = (type) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_FILTER_LIST}/${type}`);
  return response;
};

export const transactionServiceEnableListAccount = (type) => async () => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TR_OWNER_LIST}/${type}?enabledFor=ACCOUNT`,
  );
  return response;
};

export const transactionSavedFilterList = (ids, svcType) => async () => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TR_SAVED_FILTER_LIST}/${svcType}/0/0?ids=${ids}`,
  );
  return response;
};

export const getTransactioonOwnerList = (type, enabledFor) => async () => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TR_OWNER_LIST}/${type}?enabledFor=${enabledFor}`,
  );
  return response;
};

export const postTransactionAssignUser = () => async () => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_ASSIGN}`);
  return response;
};

export const createTransactionTask = (payload) => async () => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_CREATE_TASK}`, payload);
  return response;
};

export const getTransactionTaskList = (txnRefId) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_GET_TASK_LIST}?refId=${txnRefId}`);
  return response;
};

export const addTransactionComment = (payload) => async () => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_ADD_COMMENT}`, payload);
  return response;
};

export const getTransactionCommentList = (id) => async () => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_GET_COMMENT_LIST}${id}`);
  return response;
};

export const deleteTransactionComment = (id) => async () => {
  const response = await ApiService.Delete(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_DELETE_COMMENT}${id}`);
  return response;
};

export const getTransactionLookupList = (id, type, incFields, lookupKeyword, pageValue, lookupDynamicFilterData) => async () => {
  const displayFields = getDisplayFields(incFields, lookupKeyword, type);
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TR_LOOKUP_LIST}${id}/${type}/${pageValue.pageIndex}/${pageValue.pageSize}?incFields=${displayFields}`;
  if (lookupKeyword) {
    url = `${url}&searchText=${lookupKeyword}`;
  }
  if (lookupDynamicFilterData !== undefined && lookupDynamicFilterData !== null && Object.keys(lookupDynamicFilterData)?.length > 0) {
    url = `${url}&filter=${encodeURIComponent(JSON.stringify(lookupDynamicFilterData))}`;
  }

  const response = await ApiService.Get(url);
  return response;
};

export const getTransactionTeamList = (id) => async () => {
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TEAM_LIST}?ids=${id}`;
  const response = await ApiService.Get(url);
  return response;
};

// export const transactionList = (id) => async () => {
//   const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TR_LIST}/${id}/1/10`);
//   return response;
// };

// =============================================================================================================================
// =========================================================================================================================
// Get the txn deatils based on the txn id.
export const getTxnDetailsByTxnID = async (txnId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_DETAILS}/${txnId}`);
  return response;
};

// =========================================================================================================================
// Get the subform deatils based on the subform id.
export const getSubformDataById = async (txnId, subformId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.SUB_FROM_DATA}/${txnId}/${subformId}`);
  return response;
};

// =========================================================================================================================
// Update txn data based on the txn id.
export const updateTxnForm = async (payload, txnId) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_UPDATE}/${txnId}`, payload);
  return response;
};

export const updateTxnFormBulk = (acctId, txnId, type, payloadData) => async () => {
  switch (type) {
    case 'QUICK_ACTION': {
      const response = await ApiService.Post(
        `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_UPDATE}/bulk?ids=${txnId}`,
        payloadData,
      );
      return response;
    }

    case 'OWNER': {
      const response = await ApiService.Get(
        `${ApiService.baseURL}/${ApiLibrary?.V2?.TR_ASSIGN}/bulk/${acctId}?ids=${txnId}`,
      );
      return response;
    }
    default:
      break;
  }
};

// =========================================================================================================================
// Get the activity list by specific field based on the txn id.
export const getTxnActivityList = async (pageIndex, pageSize, txnId) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_ACTIVITY_LIST}/${pageIndex}/${pageSize}?id=${txnId}`,
  );
  return response;
};

// =========================================================================================================================
// Get the asserts list by specific field based on the txn id.
export const getTxnAssertsList = async (txnId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_ASSERT_LIST}?id=${txnId}`);
  return response;
};

// =========================================================================================================================
// deleting the assert based on the assert id.
export const deleteAssertById = async (assertId) => {
  const response = await ApiService.Delete(`${ApiService.baseURL}/${ApiLibrary?.V2?.ASSERT_DELTE}/${assertId}`);
  return response;
};

// =========================================================================================================================
// assert create for the perticular txn id.
export const assertCreate = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.ASSERT_CREATE}`, payload);
  return response;
};

// =========================================================================================================================
// assert update based on the assert id.
export const assertUpdate = async (payload, assetId) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.ASSERT_UPDATE}/${assetId}`, payload);
  return response;
};

// =========================================================================================================================
// create subform txn data
export const createSubFormDataById = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.SUBFORM_CREATE}`, payload);
  return response;
};

// =========================================================================================================================
// update subform txn data
export const updateSubFormDataById = async (payload, docId) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.SUBFORM_UPDATE}/${docId}`, payload);
  return response;
};

// =========================================================================================================================
// assert upload
export const assertUpload = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.ASSERT_UPLOAD}`, payload);
  return response;
};

// =========================================================================================================================
// getting chart data
export const getDashboardExecute = async (queryParams, id) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.CHART_DATA}${id}?${queryParams}`);
  return response;
};

export const updateDashboardExecute = async (queryParams, id, payloadData) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.CHART_DATA_FIELDS}${id}?${queryParams}`,
    payloadData,
  );
  return response;
};

export const getPieGraphDashboardExecute = async (queryParams, id, labelOptions) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.CHART_DATA}${id}?optionFilter=${labelOptions}&${queryParams}`,
  );
  return response;
};

// assert upload
export const getRefChildsDetailsLookupByField = async (
  pageIndex,
  pageSize,
  parentType,
  userId,
  childType,
  refField,
  incFields,
  ownerId,
) => {
  let getURL = `${ApiService.baseURL}/${ApiLibrary?.V2?.LOOKUP_DATA}/${parentType}/${userId}/${childType}/${refField}/${pageIndex}/${pageSize}`;

  if (incFields) {
    getURL += `?incFields=${incFields}`;
  }

  if (incFields && ownerId) {
    getURL += `&ownerId=${ownerId}`;
  }
  const response = await ApiService.Get(`${getURL}`);
  return response;
};

// =========================================================================================================================
// Get the table rows list.
export const getTableRowsList = async (txnId, refTableId) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_LIST}/${txnId}/${refTableId}`,
  );
  return response;
};

// =========================================================================================================================
// assert upload
export const getTxnList = async (payload, perspectiveId, pageIndex, pageSize) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_LIST}/${perspectiveId}/${pageIndex}/${pageSize}`,
    payload,
  );
  return response;
};

// =========================================================================================================================
// Get the dashboard data based on the ids.
export const getDashboardListByIds = async (dashboardIds) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.DASHBOARD_LIST}?ids=${dashboardIds}`);
  return response;
};

// Get the dashboard modal data based on the graph id.
export const getDashboardById = async (dashboardId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.DASHBOARD_BY_ID}/${dashboardId}`);
  return response;
};

// =========================================================================================================================
// Get the assert list by specific field based on the txn id.
export const getAttachmentsList = async (fieldId, txnId) => {
  const url =
    fieldId !== '' && fieldId !== undefined
      ? `${ApiService.baseURL}/${ApiLibrary?.V2?.ASSERT_LIST}?forId=${fieldId}&id=${txnId}`
      : `${ApiService.baseURL}/${ApiLibrary?.V2?.ASSERT_LIST}?refId=${txnId}`;
  const response = await ApiService.Get(`${url}`);
  return response;
};

// ================================================== Transactions Actions ========================================================

// Post API for Transactions Update
export const getTransactionUpdatedList = async (nextPageIndex, pageSize, txnId, payload) => {
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2.TR_LIST}/${txnId}/${nextPageIndex}/${pageSize}?vMode=LIST`;
  const response = await ApiService.Post(url, payload);
  return response;
};

// Get Quick Actions and WorkFlow Actions Fields Data
export const getTransactionsFieldsData = async (txnId, fieldsName) => {
  const pAccessId = getPaccessId();

  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_DETAILS}/${txnId}`
  if (pAccessId !== '' && pAccessId !== undefined) {
    url = `${url}/${pAccessId}`;
  }
  if (fieldsName) {
    url = `${url}?fields=${fieldsName}`;
  }
  const response = await ApiService.Get(
    `${url}`,
  );
  return response;
};

// Get Transactions WorkFlow Actions Acquire Action Data
export const getAcquireWorkflowActionData = async (txnId, actionRefId) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_DETAILS}/${txnId}/action/${actionRefId}/acquire`,
  );
  return response;
};

// Update WorkFlow Actions Fields Data based on the acquire data id
export const updateTransactionActionExecute = async (acquireDataId, payload) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TRANSACTION_ACTION_EXECUTE}/${acquireDataId}`,
    payload,
  );
  return response;
};
// =======================================================================================================================================

// subform preview fields data.
export const getSubformPreviewFieldsData = async (payload, txnId) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.SUB_FORM_PREVIEW}/${txnId}`, payload);
  return response;
};

// action count for all the apps.
export const getActionCount = async (ids, types) => {
  const url =
    types !== '' && types !== undefined
      ? `${ApiService.baseURL}/${ApiLibrary?.V2?.APPS_ACTION_COUNT}/ids=${ids}?types=${types}`
      : `${ApiService.baseURL}/${ApiLibrary?.V2?.APPS_ACTION_COUNT}/ids=${ids}`;
  const response = await ApiService.Get(`${url}`);
  return response;
};

// Update biz favourite dashboard data
export const updateBizDashboardConfig = async (payload) => {
  const bizAccountId = getLoginAccountId();
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.FAVOURITE_DASHBOARDS}/${bizAccountId}`,
    payload,
  );
  return response;
};

export const userAccountUploadImage = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.USER_ACCOUNT_IMAGE_UPLOAD}`, payload);
  return response;
};

export const updateUserAccountProfileDetails = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.GET_USER_ACCOUNT_DETAILS}`, payload);
  return response;
};

export const getTxnNotificationActivityModal = async (id) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TRANACTION_NOTIFICATION_ACTIVITY_MODAL}/${id}`,
  );
  return response;
};

export const getTxnNotificationAssetModal = async (id) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TRANACTION_NOTIFICATION_MODAL_ASSET_MODAL}/${id}`,
  );
  return response;
};

export const getTxnNotificationCommentModal = async (id) => {
  const response = await ApiService.Get(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TRANACTION_NOTIFICATION_MODAL_COMMENT_MODAL}/${id}`,
  );
  return response;
};

// =========================================================================================================================
// Get the table rows deatils based on the table id.
export const getTableRowsById = async (txnId, tableId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROWS_DATA}/${txnId}/${tableId}`);
  return response;
};

// add table row
export const addTableRow = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.ADD_TABLE_ROW}`, payload);
  return response;
};

// update table row data by table id.
export const updateTableRow = async (payload, tableId) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.UPDATE_TABLE_ROW}/${tableId}`,
    payload,
  );
  return response;
};

// remove table row data by id
export const removeTableRow = async (rowId) => {
  const response = await ApiService.Delete(`${ApiService.baseURL}/${ApiLibrary?.V2?.DELETE_TABLE_ROW}/${rowId}`);
  return response;
};

// update table row order by row id.
export const updateTableRowOrder = async (payload, txnId, tableId) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.ROW_ORDER_UPDATE}/${txnId}/${tableId}`,
    payload,
  );
  return response;
};

// remove table bulk rows by data
export const removeTableBulkRows = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BULK_ROWS_DELETE}`, payload);
  return response;
};

// remove table bulk rows by data
export const addTableBulkRows = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BULK_ROWS_ADD}`, payload);
  return response;
};

// Get the table rows deatils based on the table id.
export const getLookupTxnData = async (txnId, tableId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROWS_DATA}/${txnId}/${tableId}`);
  return response;
};
// get the lookup data by lookup id and lookup type
export const getLookupSelectedObj = (id, type) => async () => {
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TR_LOOKUP_LIST}${type}/${id}`;
  const response = await ApiService.Get(url);
  return response;
};

// TASKS

// GET TASKS LIST
export const getTasksList = async (nextPageIndex, tasksQueryParams, tabView, keyword) => {
  let updatedQueryString = tasksQueryParams;
  if (tabView === 'CLOSED') {
    const params = new URLSearchParams(tasksQueryParams);
    const paramsObject = {};
    params.forEach((value, key) => {
      paramsObject[key] = value;
    });

    paramsObject.status = 'COMPLETED';

    updatedQueryString = new URLSearchParams(paramsObject).toString();
  }

  // Make a GET request to retrieve users tasks list
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2.TASKS_LIST}/${nextPageIndex}/15`;
  url = keyword ? `${url}?${updatedQueryString}&keyword=${keyword}` : `${url}?${updatedQueryString}`;

  const response = await ApiService.Get(url);
  return response;
};

// UPDATE TASKS
export const updateTasksList = async (tasksId, payload) => {
  // Make a Post request to update tasks
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2.TASK_UPDATE}/${tasksId}`, payload);
  return response;
};

// CREATE TASKS
export const createTasks = async (payload) => {
  // Make a Post request to create tasks
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2.TASK_CREATE}`, payload);
  return response;
};

export const getTasksServiceData = async (svcType) => {
  // Make a Get request to get service data
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.HOME_SERVICE_DATA}/${svcType}`);
  return response;
};

// GET TASKS LIST BY ID
export const getTasksListById = async (txnId) => {
  // Make a GET request to retrieve txn tasks list by id
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2.TASKS_LIST}?refId=${txnId}`;

  const response = await ApiService.Get(url);
  return response;
};

// GET DATA IMPORTS LIST BY SVC TYPE.
export const getImportListBySvcType = async (svcType, pageIndex, pageSize) => {
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_CSV_LIST}/${svcType}/${pageIndex}/${pageSize}`;
  const response = await ApiService.Get(url);
  return response;
};

// CREATE DATA IMPORT
export const startImport = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_CSV_CREATE}`, payload);
  return response;
};


// CREATE DATA IMPORT
// FILE UPLOAD
export const uploadFileDataImport = async (payload, id) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_FILE_UPLOAD}/${id}`, payload);
  return response;
};

// Publish data import by Id.
export const publishDataImportById = async (id) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_PUBLISH}/${id}`);
  return response;
};

// Run data import by Id.
export const runDataImportById = async (id) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_RUN}/${id}`);
  return response;
};


// Execute data import by Id.
export const executeDataImportById = async (id) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_EXECUTE}/${id}`);
  return response;
};


// get Error Logs Details
export const getErrorLogsData = async (runId, state, pageIndex) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_ERROR_LOGS}/${runId}/${pageIndex}/20?state=${state}`);
  return response;
};


// get data import by Id.
export const getDataImportById = async (id) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2.TXN_DATA_IMPORT_DETAILS_ID}/${id}`);
  return response;
};

// Get txn list data by txnId
export const getTxnListDataById = async (txnId, pAccessId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_DETAILS}/${txnId}/${pAccessId}`);
  return response;
};

// update table bulk rows 
export const updateTableBulkRows = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.BULK_ROWS_UPDATE}`, payload);
  return response;
};

// assert upload
export const tableAssertUpload = async (payload) => {
  const response = await ApiService.Post(`${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ASSERT_UPLOAD}`, payload);
  return response;
};

// Get the assert list by specific field based on ids.
export const getTableRowAttachmentsList = async (fieldId) => {
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_ASSERT_LIST}?ids=${fieldId}`
  const response = await ApiService.Get(`${url}`);
  return response;
};

// =========================================================================================================================
// Get the comments list by comments ids.
export const getTableRowCommentsList = async (fieldId) => {
  const url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_COMMENTS_LIST}?ids=${fieldId}`
  const response = await ApiService.Get(`${url}`);
  return response;
};


// update table row assert data by table id.
export const updateTableRowAssert = async (payload) => {
  const response = await ApiService.Post(
    `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_UPDATE_ASSERT_CREATE}`,
    payload,
  );
  return response;
};


// update table row comment data by table id.
export const updateTableRowComment = async (payload, rowId, pAccessId) => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_UPDATE_COMMENT_CREATE}`;
  if (rowId) {
    url = `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_UPDATE_COMMENT_CREATE}?rowId=${rowId}&pAccId=${pAccessId}`;
  }
  const response = await ApiService.Post(url, payload);
  return response;
};


// =========================================================================================================================
// Get the txn list by using table dashboard id.
export const getTxnListDataByTableId = async (tableDahboardId) => {
  const response = await ApiService.Get(`${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_DASHBOARD_TXN_LIST}/${tableDahboardId}`);
  return response;
};


/**
 * The function `bizGetTeamMembersList` makes an API call to retrieve a list of team members based on
 * the provided ID.
 * @param id - The `id` parameter is the identifier of the team for which you want to retrieve the list
 * of team members.
 * @returns The response from the API call is being returned.
 */
export const getTeamMembersListByTeamId = (nextPageIndex, id, keyword) => async () => {
  let url = `${ApiService.baseURL}/${ApiLibrary?.V2.BIZ_GET_TEAM_MEMBERS}${id}/${nextPageIndex}/0`;
  url = keyword ? `${url}?keyword=${keyword}` : url;

  const response = await ApiService.Get(url);
  return response;
};


